import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface BillingInfoState {
    country: string;
    line1: string;
    line2: string;
    line3: string;
    city: string;
    state: string;
    phone: string;
}

const initialState: BillingInfoState = {
    country: "",
    line1: "",
    line2: "",
    line3: "",
    city: "",
    state: "",
    phone: ""
};

const billingInfoSlice = createSlice({
    name: "billingInfo",
    initialState,
    reducers: {
        setBillingInfo(state, action: PayloadAction<BillingInfoState>) {
            state.country = action.payload.country;
            state.line1 = action.payload.line1;
            state.line2 = action.payload.line2;
            state.line3 = action.payload.line3;
            state.city = action.payload.city;
            state.state = action.payload.state;
            state.phone = action.payload.phone;
        },
        resetBillingInfoState() {
            return initialState;
        }
    }
});

export const { resetBillingInfoState, setBillingInfo } =
    billingInfoSlice.actions;

export default billingInfoSlice.reducer;
